import { defineMessages } from 'react-intl';

export const PlaylistConstants = Object.freeze({
  TITLE_MAX_CHARACTER_LIMIT: 40,
  DEFAULT_PLAYLIST_TITLE: 'New Playlist',
  OPTIMISTIC_GET_TRACKS_RETRY_MAX: 3,
});

export const ActionTypes = Object.freeze({
  ANNOTATE_PLAYLISTS: 'ANNOTATE_PLAYLISTS',
  APPEND_ITEMS: 'APPEND_ITEMS',
  CREATE_PLAYLIST: 'CREATE_PLAYLIST',
  CLEAR_PLAYLIST_TRACKLIST: 'CLEAR_PLAYLIST_TRACKLIST',
  DELETE_PLAYLIST: 'DELETE_PLAYLIST',
  CONFIRM_DELETE_PLAYLIST: 'CONFIRM_DELETE_PLAYLIST',
  DELETE_TRACK: 'DELETE_TRACK',
  GET_PLAYLIST_AUTOFILL_TRACKS: 'GET_PLAYLIST_AUTOFILL_TRACKS',
  GET_PLAYLIST_RECOMMENDATIONS: 'GET_PLAYLIST_RECOMMENDATIONS',
  GET_TRACKS: 'GET_TRACKS',
  INSERT_TRACK: 'INSERT_TRACK',
  INTENT_ADD_TRACK_FOR_FEEDBACK: 'INTENT_ADD_TRACK_FOR_FEEDBACK',
  INTENT_DELETE_TRACK_FOR_FEEDBACK: 'INTENT_DELETE_TRACK_FOR_FEEDBACK',
  MOVE_TRACK: 'MOVE_TRACK',
  ON_FEEDBACK_UPDATE_COMPLETION: 'ON_FEEDBACK_UPDATE_COMPLETION',
  SET_DETAILS: 'SET_DETAILS',
  UNLOCK_PLAYLIST_AND_NOTIFY: 'UNLOCK_PLAYLIST_AND_NOTIFY',
  SHUFFLE_TRACKS: 'SHUFFLE_TRACKS',
  MAKE_OPTIMISTIC_EDIT: 'MAKE_OPTIMISTIC_EDIT',
  ROLLBACK_OPTIMISTIC_EDIT: 'ROLLBACK_OPTIMISTIC_EDIT',
  MAKE_OPTIMISTIC_DELETE: 'MAKE_OPTIMISTIC_DELETE',
  INVALIDATE_OFFSETS: 'INVALIDATE_OFFSETS',
  SAVE_OPTIMISTIC_ROLLBACK_DATA: 'SAVE_OPTIMISTIC_ROLLBACK_DATA',
  DELETE_OPTIMISTIC_PLAYLIST_DATA: 'DELETE_OPTIMISTIC_PLAYLIST_DATA',
  UPDATE_OPTIMISTIC_GET_TRACKS_RETRY: 'UPDATE_OPTIMISTIC_GET_TRACKS_RETRY',
  SET_ARE_VOICE_TRACKS_ENABLED: 'SET_ARE_VOICE_TRACKS_ENABLED',
});

export const messages = defineMessages({
  songs: {
    id: 't.songOrSongs',
    defaultMessage: `{numSongs, plural,
      one {# song}
      other {# songs}
    }`,
  },
  playlistBy: {
    id: 't.playlistBy',
    defaultMessage: 'Playlist by {author}',
  },
  playlistMadeFor: {
    id: 't.playlistMadeFor',
    defaultMessage: 'Playlist made for {author}',
  },
  playlistMadeForYou: {
    id: 't.playlistMadeForYou',
    defaultMessage: 'Playlist made for you',
  },
  playlist: {
    id: 't.playlist',
    defaultMessage: 'Playlist',
  },
});

export default ActionTypes;
